import Hero from '../components/Hero';
import '../styles/Pages.css';
function LifeScienceServices({ setCurrentPage }) {
    return (
      <>
      <Hero title="Life Science Services" image="/images/lifescienceservice.jpg" compact />
      <div className="page service-page">
  <div className="service-content">
          <div>
            <img src="/images/lifescienceservice.jpg" alt="Life Science Services" />
          </div>
          <div className="service-text">
            <h3>Life Science Services</h3>
            <p>
              Digicloudllc has been a leader in transforming life sciences by moving away from
              fee-for-service models to patient-centric, value-based, and affordable healthcare
              services. They empower clients through digital staffing, innovative medical
              technologies, and collaboration. Their offerings in staffing, strategy, consulting,
              operations, and technology are designed to provide personalized care and improve
              patient outcomes. Trusted for two decades, Digicloudllc connects top talent with
              impactful opportunities.
            </p>
            <p>
              Life science services encompass a wide range of specialized support functions
              designed to advance research, development, and commercialization in fields such as
              biotechnology, pharmaceuticals, medical devices, and healthcare.
            </p>
            <button className="cta-button" onClick={() => setCurrentPage('Contact')}>
              Get Started Today
            </button>
          </div>
        </div>
  
        <section className="about-section">
          
        </section>
      </div>
      </>
    );
  }
  
  export default LifeScienceServices;